export default __webpack_public_path__ + "static/media/Nunito-Bold.2d6486cd.woff2";